import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import CustomField from '../../model/refbooks/field';
import CustomFields from '../../collection/refbooks/fields';
import FieldFormTemplate from './fields.form.template';
import i18n from '../../i18n';

import Config from '../../config';

import { restrict,  } from '../../model/actions';
import { roleA, roleAC } from '../../roles';
import { ask, } from '../../utils/popups';
import { pst } from '../../http/api';
import { hashify } from '../../utils/arrays';





let ifn; i18n.then( i => ifn = i );

const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
    sortCluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/fields.list',

    url() {
        return 'custom-fields';
    },

    open() {
        const actions = this.options.actions = {
            
            defaults: 'edit',
            
            create: restrict( roleAC, 

                () => !this.options.dragMode,

                // todo set cluster if filter is not empty
                () => this.trigger( FieldFormTemplate.OPEN_FIELD, 
                    new CustomField(),
                    this.state().cluster ) ),

            edit: restrict( roleAC, 

                () => !this.options.dragMode,

                current => this.trigger( FieldFormTemplate.OPEN_FIELD, current.clone() ) ),
                
            destroy: restrict( roleAC, 

                () => {
                    if (roleA.includes( Config.role() ))
                        return true;

                    // can see only "my" fields: with cluster == my cluster;
                    // there are only global and "my" fields in the list;
                    // so, let's check only presence of cluster in field
                    // to separate "my".
                    return !!this.options.paged
                        .current().get( 'cluster' );
                },

                current => {
                    const { page } = this.state();
                    // length will be updated by "destroy" call on model
                    const length = this.options.paged.length;

                    ask( 'field::modal delete - confirmation text',
                        'field::modal delete - title', 'actions::yes', 'actions::no',
                        () => this.options.source.destroy( current ) )
                        .then( () => {
                            if (length === 1 && page > 1)
                                    this.setState( { page: page - 1, } );
                        } )
                        .then( () => this.sort() )
                        .then( () => this.render() )
                        .then( () => this.navigated() ) 
                } ),
            
            sort: restrict( roleAC, 

                () => {
                    return this.getClustersAvailableToSort().length > 0;
                },

                () => {
                    const { cluster } = this.state();
                    const availableClusters = this.getClustersAvailableToSort();
                    // check whether is current cluster can be set as sort-cluster
                    const isAvailable = availableClusters.some( candidate =>
                        cluster && cluster.id == candidate.id );

                    this.options.filter.set(
                        'sortCluster', isAvailable ? cluster : availableClusters[0],
                        { silent: true } );

                    // set flag to force sort() take cluster from sort-filter
                    this.options.dragMode = true;
                    // need to iterate all clusters (options.source) because cluster filter
                    // may be changing during sorting process
                    this.options.source.models
                            .forEach( model => model.set( 'new-order', model.get( 'order' ) ) )
                    this.setState( { page: 1 } );
                    this.sort( { sort: 'order', direction: 'asc' } )
                        .then( () => this.render() );
                } ),

            applySort: restrict( roleAC, 
                
                () => this.isOrderChanged(),

                () => pst( '/fields/sort' ).cerebellum().blocking( this )
                    .body( { 
                        ids: this.options.sorted.models
                            .map( model => [model.id, model.get( 'new-order' )] )
                            .sort( ([idA, indexA], [idB, indexB]) => indexA - indexB )
                            .map( ([id]) => id ) 
                    } )
                    .execute()
                    .then( () => this.options.sorted.models
                        .forEach( model => model.set( 'order', model.get( 'new-order' ) ) ) )
                    .then( () => this.options.dragMode = false )
                    .then( () => this.sort() )
                    .then( () => this.render() ) ),

            cancelSort: restrict( roleAC, 
                () => Promise.resolve()
                    // drop drag-mode first
                    .then( () => this.options.dragMode = false )
                    // then sort
                    .then( () => this.sort() )
                    .then( () => this.render() ) ),
                    
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )
        this.options.source = new CustomFields( this.options.fields.models );
        this.options.sorted = new CustomFields();
        this.options.filtered = new CustomFields();
        this.options.paged = new CustomFields( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

    getClustersAvailableToSort() {
        const myClusters = hashify( Config.clusters()
            .map( cluster => +cluster.id ) );

        // gather fields in arrays by cluster id
        // (null for global)
        const hash = hashify( this.options.filtered,
            (model, hash) => {
                const clusterKey = model.cluster ? model.cluster.id : null;
                const clusterObj = hash[clusterKey] || {
                    cluster: model.cluster,
                    list: []
                };

                return clusterObj.list = [...clusterObj.list, model],
                    [clusterKey, clusterObj];
            } );

        // filter groups by clusters
        return Object.values( hash )
            .filter( ({ cluster }) => roleA.includes( Config.role() )
                // chief admin can sort any group
                ? true
                // cluster admin can sort only his groups
                : cluster && myClusters[cluster.id] )
            // must be more than one item in filtered group to sort
            .filter( ({ list }) => list.length > 1 )
            .map( ({ cluster }) => cluster )
            // replace "global" null-cluster with fake value
            .map( cluster => cluster
                ? cluster
                : { id: -1, title: ifn( 'filters::global' ) } )
            .sort( (clA, clB) => {
                if (clA.id == -1)
                    return -1;
                else if (clB.id == -1)
                    return 1;
                else if (clA.title < clB.title)
                    return -1;
                else if (clA.title > clB.title)
                    return 1;
                else
                    return 0;
            } );
    }

} );


// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.list.js